import { LoadingButton } from '@mui/lab';
import { Autocomplete, Box, Button, CircularProgress, TextField } from '@mui/material';
import { useState } from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Proptypes from 'prop-types';
import { format } from 'date-fns';
import FileDownload from 'js-file-download';

import { api as stockApi } from '../../store/domains/stock';
import { useAutoCompleteState } from '../../hooks/useAutoCompleteState';
import Render from '../Render';

const IccidFileUpload = ({ handleClose, hubId, isTransfer, isUnassign }) => {
  const [fileUploadMutation, { isLoading }] = stockApi.usePostAssignIccidWithFile();
  const [unassignFileMutation, { isLoading: unassignFileMutationLoading }] = stockApi.usePostUnassignIccidWithFile();
  const [fileUploadTransferMutation, { isLoading: isLoadingTransfer }] = stockApi.usePostAssignIccidWithFileTransfer();

  const { data: posManagerOrganizations, isLoading: posManagerLoading } = stockApi.useGetPosManagerOrganizations(
    hubId,
    {
      skip: !hubId,
    }
  );

  const { data: posManagerPartners, isLoading: posManagerOrganizationsLoading } = stockApi.useGetOrganizations(null, {
    skip: !isTransfer,
  });
  const [partnerId, handleChange] = useAutoCompleteState(isTransfer);
  const [toPartner, handleChangeToPartner] = useAutoCompleteState(isTransfer);
  const [file, setFile] = useState();

  function handleChangeForm(event) {
    setFile(event.target.files[0]);
  }

  const onSubmit = () => {
    const form = new FormData();
    form.append('file', file);

    if (isTransfer) {
      const json = JSON.stringify({ fromPartner: partnerId, toPartner });
      const blob = new Blob([json], {
        type: 'application/json',
      });
      form.append('transferStockDto', blob);
      fileUploadTransferMutation(form)
        .unwrap()
        .then((response) => {
          const date = format(new Date(), 'yyyy-MM-dd-HH-mm-ss');
          FileDownload(response, `IccidTransferResult-${date}.xlsx`);
        })
        .finally(() => {
          handleClose();
        });
      return;
    }

    if (isUnassign) {
      unassignFileMutation(form)
        .unwrap()
        .then((response) => {
          const date = format(new Date(), 'yyyy-MM-dd-HH-mm-ss');
          FileDownload(response, `IccidUnassignResult-${date}.xlsx`);
        })
        .finally(() => {
          handleClose();
        });
      return;
    }

    form.append('partnerId', partnerId);
    fileUploadMutation(form)
      .unwrap()
      .then((response) => {
        const date = format(new Date(), 'yyyy-MM-dd-HH-mm-ss');
        FileDownload(response, `IccidAssignResult-${date}.xlsx`);
      })
      .finally(() => {
        handleClose();
      });
  };
  if (posManagerLoading || posManagerOrganizationsLoading || unassignFileMutationLoading) {
    return <CircularProgress />;
  }

  return (
    <Box paddingTop={4}>
      <Render shouldRender={!isUnassign}>
        <Autocomplete
          value={partnerId}
          onChange={handleChange}
          options={posManagerOrganizations || []}
          renderInput={(params) => <TextField {...params} label="Select Partner" />}
          fullWidth
        />
      </Render>
      <Render shouldRender={isTransfer}>
        <Autocomplete
          value={toPartner}
          onChange={handleChangeToPartner}
          options={posManagerPartners || []}
          renderInput={(params) => <TextField {...params} label="Select Partner to transfer" />}
          fullWidth
          sx={{ mt: 2 }}
        />
      </Render>
      <Box display="flex" alignItems="center">
        <Button
          sx={{
            marginTop: 3,
          }}
          variant="contained"
          component="label"
        >
          Upload File
          <input onChange={handleChangeForm} type="file" hidden />
        </Button>
        {file && (
          <Box display="flex" alignItems="center" marginLeft={4}>
            {file.name}
            <CheckCircleOutlineIcon sx={{ marginLeft: 1 }} color="success" />
          </Box>
        )}
      </Box>

      <LoadingButton
        loading={isLoading}
        disabled={isLoading || !file || (!partnerId && !isUnassign) || isLoadingTransfer}
        onClick={onSubmit}
        sx={{ my: 2 }}
        fullWidth
        size="large"
        type="submit"
        variant="contained"
      >
        Submit
      </LoadingButton>
    </Box>
  );
};

IccidFileUpload.propTypes = {
  handleClose: Proptypes.func,
  hubId: Proptypes.number,
  isTransfer: Proptypes.bool,
  isUnassign: Proptypes.bool,
};
export default IccidFileUpload;
